import { SHOW_SNACKBAR_SUCCESS, SHOW_SNACKBAR_ERROR, HIDE_SNACKBAR } from '../constants/actionTypes';

const INITIAL_STATE = { message: '', open: false, action: null, severity: null };

export default function snackbar(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SHOW_SNACKBAR_SUCCESS:
      return {
        ...state,
        message: action.payload.message,
        open: true,
        action: action.payload.action,
        severity: 'success'
      };

    case SHOW_SNACKBAR_ERROR:
      return {
        ...state,
        message: action.payload.message,
        open: true,
        action: action.payload.action,
        severity: 'error'
      };

    case HIDE_SNACKBAR:
      return {
        ...state,
        message: '',
        open: false
      };
    default:
      return state;
  }
}
